import React from 'react'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import MenuDotsIcon from './MenuDotsIcon'
import { useSelector } from 'react-redux';
import { selectIsMobileRoute } from '../../../features/mobile/mobileSlice';
import BackDotsIcon from './BackDotsIcon';

export default function MenuButton(redirectURL?: any) {
    const AppURL = useSelector(selectIsMobileRoute);
    const urlParams = AppURL ? `/?${AppURL}` : '';
    const isSettingURL = redirectURL.redirectURL ? true : false;
    const redirectLink = isSettingURL ? redirectURL.redirectURL : `/my-account${urlParams}`;
    const urlState = redirectURL.urlState ? redirectURL.urlState : {};

    return (
        <Button
            as={Link as any}
            to={redirectLink}
            state={urlState}
            variant="white"
            size="lg"
            className='p-0 no-hover-effect'
        >
            <div className='d-flex flex-column align-items-start justify-content-center'>
                {!isSettingURL && <span className="text-uppercase fs-15px pb-1 ps-1 font-glegoo">Menu</span>}
                <div className='mtnegative8px position-relative d-inline-block'>
                    {isSettingURL ? <BackDotsIcon /> : <MenuDotsIcon width={45} height={40} />}
                </div>
            </div>
        </Button>
    )
}
